import { Component, Input, ViewEncapsulation } from '@angular/core';
import { Asset } from '../../../api/asset/asset';

@Component({
    selector: 'asset-detail',
    templateUrl: './asset-detail.component.html',
    styleUrls: ['./asset-detail.component.css'],
    host: {'class': 'asset-detail'},
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class AssetDetailComponent {
  @Input() asset: Asset | null | undefined = null;

}
